module.exports = __webpack_public_path__ + "static/media/ppc-views.fd4034d5.png";